module.exports = __webpack_public_path__ + "fonts/Trade-Gothic-Bold.svg";


//////////////////
// WEBPACK FOOTER
// ./Common/fonts/Trade-Gothic-Bold.svg
// module id = 23
// module chunks = 0 1 2 3 4 5 6 7